import React from 'react'
import './style.css'
const index = () => {

    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }
  
    return (
          <div className="component-desc">
            <h2 className="heading">Button</h2>
            <div className="description">Buttons are one of the most important element of a website. Buttons allow users to perform actions with a single click.</div>
            <div className="divider"></div>
            <h4 className="heading">Primary Button</h4>
            <div style={{display:'flex', justifyContent:'center'}}>
                <button className="btn btn--primary btn--block">Buy Now</button>
                <button className="btn btn--secondary">Buy Now</button>
            <button className="btn btn--accent">Buy Now</button>
            </div>
            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%252F*primary%2520button*%252F%250A%253Cbutton%2520class%253D%2522btn%2520btn-primary%2520btn-sm%2522%253EPrimary%253C%252Fbutton%253E%250A%253Cbutton%2520class%253D%2522btn%2520btn-primary%2520btn-md%2522%253EPrimary%253C%252Fbutton%253E%250A%253Cbutton%2520class%253D%2522btn%2520btn-primary%2520btn-lg%2522%253EPrimary%253C%252Fbutton%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
            <div className="divider"></div>
            <h4 className="heading">Link Button</h4>
            <div style={{display:'flex',justifyContent:'center',marginTop:'2rem'}}>
                <a href="#" className="btn btn--outline">buy now</a>
                <a href="#" style={{width:'75%', margin:'0 auto'}} className="btn btn--outline btn--block">buy now</a>
            </div>
            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%252F*secondary%2520button*%252F%250A%253Cbutton%2520class%253D%2522btn%2520btn-secondary%2520btn-sm%2522%253ESecondary%253C%252Fbutton%253E%250A%253Cbutton%2520class%253D%2522btn%2520btn-secondary%2520btn-md%2522%253ESecondary%253C%252Fbutton%253E%250A%253Cbutton%2520class%253D%2522btn%2520btn-secondary%2520btn-lg%2522%253ESecondary%253C%252Fbutton%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
            <div className="divider"></div>
            <h4 className="heading">Icon Button</h4>
            <div style={{display:"flex",flexDirection:"column"}}>
                <button style={{alignSelf:"center"}} className="btn btn-icon">
                  <img className="icon1" src="static/images/bookmark.svg" alt="" />
                   Bookmark
                </button>
                <div className="carbon-container">
                    <iframe
                        src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=false&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%252F*icon%2520button*%252F%250A%253Cbutton%2520class%253D%2522btn%2520btn-icon%2522%253E%253Cimg%2520class%253D%2522icon1%2522%2520src%253D%2522static%252Fimages%252Fbookmark.svg%2522%2520alt%253D%2522%2522%253E%2520Bookmark%253C%252Fbutton%253E"
                        style={frameStyle}
                        sandbox="allow-scripts allow-same-origin">
                    </iframe>
                </div>
            </div>
            <div className="divider"></div>
            <h4 className="heading">Floating action Button</h4>
            <div style={{display:'flex',flexDirection:'column'}} className="float-action">
                <button style={{alignSelf:"center"}} className="btn-fl">+</button>
            </div>
            
            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%252F*%2520floating%2520action%2520button%2520*%252F%250A%253Cdiv%2520class%253D%2522float-action%2522%253E%250A%2509%253Cbutton%2520class%253D%2522btn-float%2522%253E%252B%253C%252Fbutton%253E%250A%253C%252Fdiv%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
          </div>
  )
}

export default index